import {
  conciergeLogin,
  resetMultiEntityAllMappingsData,
  addMultiEntityFavourite,
  removeMultiEntityFavourite,
} from "../../../redux/features/multientity/multientity";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";
import SvgComponent from "../../_utils/SVGComponent";
import CommonToast from "../../_utils/CommonToast";
import ICONS from "../../../assets/Icons";

const ArrowRightWhite = ICONS?.ARROW_RIGHT_WHITE;
const NotSelectedWithGreyCircle = ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE;
const selected_with_green_circle = ICONS?.SELECTED_WITH_GREEN_CIRCLE;
const NotFavouriteIcon = ICONS?.FAVOURITE;
const FavouriteIcon = ICONS?.FAVOURITE_FILLED;
const entityIcon = ICONS?.ENTITIES_WHITE;

const MultiEntityCard = ({
  isActive,
  currentEntityName,
  currentEntityPan,
  setSelectId,
  type,
  handleCardClick,
  isSelected,
  card,
  cardSlideAnimation,
  conciergeLoading,
  setSlideCard,
  setOpenAllEntities,
  setAnimatedLoader,
  slideCard,
  cardId,
  setCardId,
}) => {
  const {
    favourite,
    id,
    primary_entity_id,
    primary_user,
    sub_entity_id,
    sub_entity_name,
    sub_entity_pan,
    sub_user,
  } = card || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { multiEntityFavouriteLoading } = useSelector(
    (state) => state.multientity,
  );

  const getIsFavouriteDisabled = () => {
    const isIt =
      (JSON.parse(sessionStorage.getItem("primary_entity_data"))?.entity
        ?.entity_id ?? "") !== sessionStorage.getItem("entity_id");
    return isIt;
  };

  const showProcessingToast = (text) => {
    CommonToast({
      text: text,
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
    });
  };

  const handleToggleFavourite = async (e) => {
    e.stopPropagation();

    if (getIsFavouriteDisabled()) {
      CommonToast({
        text: `Log in with primary ID - ${
          JSON.parse(sessionStorage.getItem("primary_entity_data"))?.employees
            ?.user_id ?? ""
        } to edit favourites.`,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return;
    }

    if (multiEntityFavouriteLoading) return;

    const newFavourite = favourite === "Y" ? "N" : "Y";
    const isAdding = newFavourite === "Y";

    const loadingToastId = showProcessingToast(
      isAdding ? "Adding to favourites" : "Removing from favourites",
    );

    const action = isAdding
      ? addMultiEntityFavourite({ entityId: id })
      : removeMultiEntityFavourite({ entityId: id });

    try {
      await dispatch(action).unwrap();

      const cachedRaw = sessionStorage.getItem("primaryEntityData");
      if (cachedRaw) {
        const cached = JSON.parse(cachedRaw);
        const updatedCache = { ...cached };

        for (const [key, value] of Object.entries(cached)) {
          if (key.endsWith("_Y")) continue;

          if (value?.mappings && Array.isArray(value.mappings)) {
            const updatedMappings = value.mappings.map((m) =>
              m.id === id ? { ...m, favourite: newFavourite } : m,
            );
            updatedCache[key] = { ...value, mappings: updatedMappings };
          }
        }

        for (const [key, value] of Object.entries(cached)) {
          if (!key.endsWith("_Y")) continue;

          let currentMappings = value?.mappings || [];

          if (isAdding) {
            const exists = currentMappings.some((m) => m.id === id);
            if (!exists) {
              const baseKey = key.replace(/_Y$/, "_");
              const baseData = cached[baseKey];
              const match = baseData?.mappings?.find((m) => m.id === id);

              if (match) {
                updatedCache[key] = {
                  ...value,
                  mappings: [...currentMappings, { ...match, favourite: "Y" }],
                  total_count: (value.total_count || 0) + 1,
                  title: {
                    ...value?.title,
                    records: (value?.title?.records || 0) + 1,
                  },
                };
              }
            }
          } else {
            const updatedMappings = currentMappings.filter((m) => m.id !== id);
            updatedCache[key] = {
              ...value,
              mappings: updatedMappings,
              total_count: updatedMappings.length,
              title: {
                ...value?.title,
                records: updatedMappings.length,
              },
            };
          }
        }

        sessionStorage.setItem(
          "primaryEntityData",
          JSON.stringify(updatedCache),
        );
      }

      window.dispatchEvent(
        new CustomEvent("favourite_updated", {
          detail: { id, newFavourite },
        }),
      );

      toast.dismiss(loadingToastId);

      CommonToast({
        text: isAdding ? "Added to favourites" : "Removed from favourites",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
    } catch (err) {
      console.error("Favourite toggle failed:", err);
      toast.dismiss(loadingToastId);
      CommonToast({
        text: "Failed to update favourite",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleConciergeLogin = async () => {
    let data = await dispatch(
      conciergeLogin({
        primary_entity_id: primary_entity_id,
        primary_user_id: primary_user,
        sub_entity_id: sub_entity_id,
        sub_user_id: sub_user,
      }),
    );

    if (data?.payload?.status === true) {
      setSlideCard(true);
      setOpenAllEntities(true);
      setTimeout(() => setAnimatedLoader(true), 600);
      setTimeout(() => {
        navigate(store, { replace: true });
        sessionStorage.removeItem("previousLog");
        sessionStorage.setItem("conciergeLogin", true);
        dispatch(resetMultiEntityAllMappingsData());
      }, 800);
    } else {
      setSlideCard(false);
      setOpenAllEntities(false);
      setAnimatedLoader(false);
      setSelectId("");
    }
  };

  let store = sessionStorage.getItem("previousLog") || "/home";

  return (
    <>
      {type === "multiEntityViewAllCard" ? (
        <div
          className={`lg:w-[var(--multi-entity-card-width)] w-full h-[calc(var(--navbar-breadcrumb-height)-var(--padding-xs))]
    flex gap-gap-sm p-padding-sm rounded-border-radius-sm transition-transform
    ${
      multiEntityFavouriteLoading
        ? "opacity-light-opacity pointer-events-none"
        : "cursor-pointer"
    }
    ${
      cardSlideAnimation
        ? "cardSlideAnimate"
        : isActive
          ? "pointer-events-none bg-primary-card cardUpSlideAnimate"
          : isSelected && isSelected(id)
            ? "global-hover-black relative z-z-index-base bg-positive-card"
            : "global-hover-white relative z-z-index-base bg-primary-nav"
    }
  `}
          onClick={() => {
            if (!isActive && !multiEntityFavouriteLoading) {
              handleCardClick(card);
            }
          }}
        >
          <div
            className={`p-padding-md rounded-md transition-transform duration-animation-fast ease-in ${
              isActive
                ? "bg-primary-bg"
                : isSelected && isSelected(id)
                  ? "bg-positive-bg"
                  : "bg-primary-card"
            }`}
          >
            <img
              src={entityIcon}
              alt="entity"
              className="w-icon-xl h-icon-xl"
            />
          </div>
          <div className="w-full relative">
            <div className="flex flex-col gap-gap-sm">
              <h4 className="text-text-primary font-semibold text-base line-clamp-2 w-[var(--max-height-top-slider)]">
                {isActive ? currentEntityName : sub_entity_name}
              </h4>
              <p className="text-text-secondary font-semibold text-sm">
                PAN number : {isActive ? currentEntityPan : sub_entity_pan}
              </p>
            </div>
            {!isActive && (
              <div
                className={`flex items-center gap-gap-sm absolute top-top-base right-right-base ${
                  multiEntityFavouriteLoading
                    ? "opacity-light-opacity"
                    : "opacity-base-opacity"
                }`}
              >
                <img
                  src={favourite === "Y" ? FavouriteIcon : NotFavouriteIcon}
                  className={`h-icon-md w-icon-md cursor-pointer ${
                    getIsFavouriteDisabled()
                      ? "opacity-light-opacity"
                      : "opacity-base-opacity"
                  }`}
                  alt="favourite"
                  onClick={handleToggleFavourite}
                />
                {isSelected(id) ? (
                  <img
                    src={selected_with_green_circle}
                    alt="SelectedWithGreenCircle"
                    className="w-icon-md h-icon-md"
                  />
                ) : (
                  <img
                    src={NotSelectedWithGreyCircle}
                    alt="NotSelectedWithGreyCircle"
                    className="w-icon-md h-icon-md"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          className={`bg-primary-nav lg:w-multi-entity-card-width w-full h-card-height flex gap-gap-sm p-padding-sm rounded-xl transition-transform duration-0.8s ease-in hover:bg-Blue-6-hover ${
            isActive ? "border border-pending" : ""
          } ${
            id === cardId && !conciergeLoading && slideCard
              ? "cardSlideAnimate"
              : slideCard
                ? "carDisplayNone"
                : ""
          } cursor-pointer`}
          style={{ pointerEvents: conciergeLoading ? "none" : "auto" }}
          onClick={() => {
            setCardId(id);
            if (isActive) {
              setSlideCard(true);
              setOpenAllEntities(true);
              setTimeout(() => setAnimatedLoader(true), 600);
              setTimeout(() => {
                navigate(store, { replace: true });
                sessionStorage.removeItem("previousLog");
                sessionStorage.setItem("conciergeLogin", true);
              }, 800);
            } else {
              setSelectId(id);
              handleConciergeLogin();
            }
          }}
        >
          <div className="bg-primary-bg p-padding-md rounded-md">
            <img
              src={entityIcon}
              alt="entity"
              className="w-icon-xl h-icon-xl"
            />
          </div>
          <div className="w-full relative pt-padding-sm">
            <div className="flex flex-col gap-gap-sm">
              <h4 className="text-text-primary font-semibold text-base line-clamp-2 w-[var(--max-height-top-slider)]">
                {isActive ? currentEntityName : sub_entity_name}
              </h4>
              <p className="text-text-secondary font-semibold text-sm">
                PAN number :&nbsp;
                {isActive ? currentEntityPan : sub_entity_pan}
              </p>
            </div>
            <div className="flex items-center gap-gap-sm absolute top-0 right-0">
              <img
                src={FavouriteIcon}
                className="w-icon-md h-icon-md cursor-pointer"
                alt="favouriteFilled"
                style={{ display: isActive ? "none" : "flex" }}
              />
              <SvgComponent
                color="var(--text-primary)"
                height={"var(--icon-md)"}
                width="var(--icon-md)"
                url={ArrowRightWhite}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MultiEntityCard;
